import React, {Component} from "react";
import _ from "lodash";
import MomentDate from "../../../components/MomentDate";
import EventHelper from "../../../helpers/EventHelper";
import {LOCAL} from "../../../constants/local";

class BetCheck extends Component {
	render() {
		const check = {
			fontFamily : 'Arial, sans-serif'
		};
		const h1 = {
			color : 'midnightblue'
		};
		const p = {
			fontWeight : 'bold',
			color      : 'maroon',
			fontSize   : 18
		};
		const table = {
			borderCollapse : 'collapse',
			width          : 780,
			border         : '1px solid #000000'
		};
		const thead = {
			background : 'lightskyblue'
		};
		const td = {
			padding     : 3,
			fontWeight  : 'bold',
			borderRight : '1px solid #000000'
		};
		const tdBody = {
			verticalAlign : 'top',
			borderRight   : '1px solid #000000',
			padding       : 3,
		};
		const pBody = {
			margin  : 0,
			padding : 0,
		};
		const spanBody = {
			fontWeight : 'bold',
		};
		const spanBodyRed = {
			color : 'red',
		};
		const divBody = {
			padding : '0 0 10px 0'
		};

		const {bet, events} = this.props;
		const {details} = bet;

		let isLive = false;
		const dt = details.map((detail) => {
			const event = _.first(events.filter((event) => {return parseInt(event.id) === detail.event_id}));

			if ( +event.type === 1 ) {
				isLive = true;
			}

			const teams = EventHelper.parseTeams(event.team1, event.team2);

			return (
				<div style={divBody}>
					<p style={pBody}>
						<span style={spanBody}>Дата:&nbsp;</span>
						<MomentDate date={event.time} isFormatDate={true}/>
					</p>
					<p style={pBody}>
						<span style={spanBody}>Событие:&nbsp;</span>
						<span>{teams}</span>
					</p>
					<p style={pBody}>
						<span style={spanBody}>Выбор:&nbsp;</span>
						<span>{detail.bet_name}: {detail.value}</span>
					</p>
				</div>
			)
		});

		return (
			<div style={check}>
				<h1 style={h1}>www.maxline.by</h1>

				<p style={p}>Ваша ставка принята, спасибо</p>
				<table style={table}>
					<thead style={thead}>
						<tr>
							<td style={td}>Описание ставки</td>
							<td style={td}>Описание выбора</td>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td style={tdBody}>
								<p style={pBody}><span style={spanBody}>Номер ставки:</span> {bet.number}</p>
								<p style={pBody}>
									<span style={spanBody}>Тип ставки:&nbsp;</span>
									{isLive && <span style={spanBodyRed}> Live </span>}
									{bet.type} {bet.count_bets > 1 && `(K=${bet.value.toFixed(2)})`}

								</p>
								<p style={pBody}><span style={spanBody}>Сумма ставки:</span> {bet.amount} {LOCAL.currency}</p>
								<p style={pBody}>
									<span style={spanBody}>Потенциальная выплата:&nbsp;</span>
									<span>{(bet.amount * bet.value).toFixed(2)} {LOCAL.currency}</span>
								</p>
								<p style={pBody}><span style={spanBody}>СККСУИ:</span></p>
							</td>
							<td style={tdBody}>
								{dt}
							</td>
						</tr>
					</tbody>
				</table>

				<p>ООО "Финансово-инвестиционная компания "ИНХО"</p>
				<p>УНП 191318808 г.Витебск, пр. Строителей, д. 10</p>
				<p>
					<span>Дата:&nbsp;</span>
					<MomentDate date={bet.ts} isFormatDate={true}/>
				</p>
				<p><span>Количество ставок:&nbsp;</span>{bet.count_bets}</p>
			</div>
		);
	}
}

export default BetCheck;


// WEBPACK FOOTER //
// ./src/app/pages/User/History/BetCheck.js